/* @ngInject */
function WorkflowAttachmentPreviewController ($sce, $timeout, $cookies, Utils, CONSTANTS, AssetService, AttachmentService) {
  const pdfjsLib = require('pdfjs-dist')
  // The workerSrc property shall be specified.
  pdfjsLib.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()

  const ctrl = this

  ctrl.previewUrl = ''
  ctrl.deskfyPreview = AssetService.getDeskfyDefaultPreviewFormats()

  const api = {
    _prepareGooglePreview,
    _initializePdfPreview
  }

  activate()

  function activate () {
    $timeout(function () {
      api._prepareGooglePreview()
    }, 500)
  }

  ctrl.getAssetUrl = function (asset) {
    if (!asset.id) {
      return
    }

    if (ctrl.attachment.type === 'VIDEO') {
      return Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_ID_STREAM, [asset.id])
    }

    return Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, [asset.id])
  }

  ctrl.getThumbnailUrl = function (asset) {
    if (!asset.id) {
      return
    }

    return Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_THUMBNAIL_ID, [asset.id])
  }

  ctrl.loadPdf = function (asset) {
    $timeout(() => {
      const targetElem = $('#pdf-preview-' + asset.id)

      if (!targetElem.length) {
        return
      }

      if (!asset.id) {
        return
      }

      AttachmentService.downloadWithProgress(asset.id,
        () => undefined,
        (blob) => {
          targetElem.find('.ui.loader').hide()
          api._initializePdfPreview(blob)
        },
        CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID,
        {
          query: {
            jwt: $cookies.get('jwt')
          },
          externalUrl: true
        })
    }, 1000)
  }

  async function _initializePdfPreview (blob) {
    const urlCreator = window.URL || window.webkitURL
    const pdfDoc = await pdfjsLib.getDocument({
      url: urlCreator.createObjectURL(blob),
      disableStream: true,
      disableAutoFetch: true
    }).promise

    const container = document.querySelector('.thumbnail-containter')
    const width = container.getBoundingClientRect().width - 24

    Array.from({ length: pdfDoc.numPages }).forEach(async (_, index) => {
      const numPage = index + 1
      const page = await pdfDoc.getPage(numPage)

      const scale = width / page.getViewport({ scale: 1.0 }).width
      const viewport = page.getViewport({ scale })

      const canvas = document.createElement('canvas')
      container.appendChild(canvas)
      canvas.width = viewport.width
      canvas.height = viewport.height
      canvas.style.margin = '12px 0 0 12px'

      page.render({
        canvasContext: canvas.getContext('2d'),
        viewport
      })
    })
  }

  function _prepareGooglePreview () {
    if (!ctrl.deskfyPreview.supportedExtensions.includes(ctrl.attachment.extension)) {
      AssetService.generateDownloadToken(ctrl.attachment.id)
        .then(token => {
          ctrl.assetToken = token
          const assetUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_ASSET_UUID_DOWNLOAD, [ctrl.assetToken])
          const previewUrl = Utils.fnReplaceStringParams(CONSTANTS.BASE_GOOGLE_PREVIEW_URL, [assetUrl])
          ctrl.previewUrl = $sce.trustAsResourceUrl(previewUrl)
        })
    }
  }
}

export { WorkflowAttachmentPreviewController }
